import styled from 'styled-components';
import { ReactNode } from 'react';

export const ShortHeroWrapper = styled.div<{
  children?: ReactNode;
}>`
margin-top: 70px;
@media screen and (min-width: 768px) {
  margin-top: 80px;
}
`;
